<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-pen', currentTabIndex === 0)" /> Pendings
        </template>
        <ReceivingPending
          ref="srPending"
          :tab-index="currentTabIndex"
          @show="showReceiving"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 1)" /> Histories
        </template>
        <ReceivingHistory
          ref="srHistory"
          :tab-index="currentTabIndex"
          @show="showReceiving"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalReceiving"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Document Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.document_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transfer Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transfer_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="SAP Entry"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.sap_doc_entry"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transferred By"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.origin_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <ValidationObserver
                ref="formProducts"
              >
                <BTable
                  ref="tableProducts"
                  small
                  hover
                  striped
                  bordered
                  responsive
                  show-empty
                  class="mb-0"
                  sticky-header="calc(100vh - 18.3rem)"
                  :stacked="tableProducts.stacked"
                  :items="stockRequest.details"
                  :fields="currentTabIndex === 0 ? tableProducts.fields : tableProducts.histories"
                  :filter="tableProducts.filter"
                  :filter-included-fields="tableProducts.filterOn"
                  :busy="tableProducts.busy"
                >
                  <template #cell(index)="{ index }">
                    <div
                      class="text-md-nowrap"
                      v-text="tableRowNumber(tableProducts, index)"
                    />
                  </template>

                  <template #cell()="{ value }">
                    <div
                      class="text-md-nowrap d-flex align-items-center min-h-35px px-1"
                      v-text="value"
                    />
                  </template>

                  <template #cell(product_name)="{ value }">
                    <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                      <strong
                        class="font-weight-bolder"
                        v-text="value"
                      />
                    </div>
                  </template>

                  <template #cell(quantity)="{ value }">
                    <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                      <strong
                        class="font-weight-bolder"
                        v-text="numberFormatter(value, '0,0')"
                      />
                    </div>
                  </template>

                  <template #cell(posting_quantity)="{ item, value }">
                    <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                      <strong
                        :class="['font-weight-bolder', {
                          'text-danger': Number(value) <= 0,
                          'text-warning': Number(value) >= 1 && Number(item.quantity) !== Number(value),
                          'text-success': Number(item.quantity) === Number(value)
                        }]"
                        v-text="numberFormatter(value, '0,0')"
                      />
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center py-5">
                      <BIcon
                        icon="stopwatch"
                        font-scale="5"
                        animation="cylon"
                      />
                      <p class="h3 py-2">
                        <strong>Loading . . .</strong>
                      </p>
                    </div>
                  </template>

                </BTable>
              </ValidationObserver>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Delivery Details</b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery Date"
                    label-for="fvDeliveryDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryDate"
                      v-model="stockRequest.delivery_details.date"
                      type="date"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Logistics Type"
                    label-for="fvDeliveryLogisticsType"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryLogisticsType"
                      v-model="stockRequest.delivery_details.logistics_type"
                      type="text"
                      maxlength="25"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol cols="12" />

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvScheduleMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleMobile"
                      v-model="stockRequest.delivery_details.mobile_number"
                      type="text"
                      maxlength="50"
                      placeholder="no mobile number"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Driver"
                    label-for="fvDeliveryDriver"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryDriver"
                      v-model="stockRequest.delivery_details.driver_name"
                      type="text"
                      maxlength="50"
                      placeholder="no driver"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                  offset-md="3"
                  offset="0"
                >
                  <BFormGroup
                    label="Helper"
                    label-for="fvDeliveryHelper"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryHelper"
                      v-model="stockRequest.delivery_details.helper"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Plate"
                    label-for="fvDeliveryVehiclePlate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryVehiclePlate"
                      v-model="stockRequest.delivery_details.vehicle_plate"
                      type="text"
                      maxlength="25"
                      placeholder="no vehicle plate"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Name"
                    label-for="fvDeliveryVehicleName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvDeliveryVehicleName"
                      v-model="stockRequest.delivery_details.vehicle_name"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>

      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="flex-grow-1 d-flex justify-content-between mb-0 pb-0 gap-2">
          <div />
          <div class="d-flex gap-2">
            <BButton
              v-if="state.receiving"
              variant="primary"
              size="sm"
              tabindex="-1"
              :disabled="state.busy"
              @click.prevent="validateReceiving"
            >
              Mask as Received
            </BButton>
            <BButton
              variant="outline-dark"
              tabindex="-1"
              size="sm"
              :disabled="state.busy"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import ReceivingPending from '@/views/user/prd/inter-warehouses/receiving/Pending.vue'
import ReceivingHistory from '@/views/user/prd/inter-warehouses/receiving/History.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

export default {

  name: 'VPRDIWReceiving',

  middleware: ['auth', 'prd'],

  metaInfo: () => ({
    title: 'Inter-Warehouse Approvals'
  }),

  components: {
    ReceivingPending,
    ReceivingHistory,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  data () {
    return {
      currentTabIndex: this.getCurrentTabIndexByURL(),
      state: {
        busy: false,
        receiving: false
      },
      stockRequest: {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          destination: '',
          destination_name: '',
          destination_code: '',
          origin: '',
          origin_name: '',
          origin_code: ''
        },
        delivery_details: {
          date: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver_name: '',
          mobile_number: '',
          logistics_type: 'In-House',
          is_3pl: 0,
          helper: ''
        },
        details: [],
        approvals: [],
        remarks: ''
      },
      requesterSignatory: {
        stage: 0,
        approver_label: 'Warehouse Officer - Origin',
        approver_action: 'Stock Transfer',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      tableProducts: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile),
        histories: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    getCurrentTabIndexByURL () {
      switch (this.$route.params.receiver) {
        case 'histories' : {
          return 1
        }
        default: {
          return 0
        }
      }
    },

    showReceiving (stockRequest, useReceiving) {
      this.state.receiving = useReceiving

      const { id, approvable } = stockRequest
      const { delivery_details } = approvable

      this.stockRequest = Object.assign(this.stockRequest, {
        id: id,
        stage: approvable.stage,
        references: {
          document_number: approvable.document_number,
          transfer_number: approvable.transfer_number,
          sap_doc_entry: approvable.sap_doc_entry,
          transaction_number: approvable.transaction_number
        },
        headers: {
          destination: approvable.destination_id,
          destination_name: approvable.destination_name,
          destination_code: approvable.destination_code,
          origin: approvable.origin_id,
          origin_code: approvable.origin_code,
          origin_name: approvable.origin_name
        },
        delivery_details: {
          date: delivery_details?.date || '',
          vehicle_plate: delivery_details?.vehicle_plate || '',
          vehicle_name: delivery_details?.vehicle_name || '',
          driver_name: delivery_details?.driver_name || '',
          mobile_number: delivery_details?.mobile_number || '',
          logistics_type: Number(delivery_details?.is_3pl) === 1 ? '3rd Party' : 'In-House',
          is_3pl: delivery_details?.is_3pl || 0,
          helper: delivery_details?.helper || ''
        },
        details: approvable.transfer_details,
        approvals: approvable.approvals,
        remarks: approvable.remarks,
        created_at: approvable.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: approvable.destination_name,
        status_at: approvable.created_at
      })

      this.$bvModal.show('modalReceiving')
    },

    validateReceiving () {
      this.swalConfirmWithRemarks({
        html: 'Receive Stock Transfer?',
        remarksRequired: true,
        preConfirm: remarks => {
          return this.$refs.srPending.update({
            id: this.stockRequest.id,
            selected: [
              {
                id: this.stockRequest.id,
                remarks: remarks
              }
            ],
            status: 'Received'
          }).catch(({ remarks }) => {
            if (remarks) {
              this.validateReceiving()
              this.$swal.showValidationMessage('The remarks field is required')
            }
          })
        },
        confirmButtonText: 'Receive',
        width: '50rem'
      })
    }

  }
}
</script>
